module.exports = __webpack_public_path__ + "img/popup-hd1.c1a9d0e0.png";